/**
 * Turkish dictionary — the primary (default) language (TD-017).
 * This file is the source of truth for translation keys: `en` must provide every key.
 * Technical terms (Ladder, Scan, Coil, TON) are intentionally kept in their original form.
 */
export const tr = {
  // ---- Application ------------------------------------------------------
  'app.name': 'PLC Simülatör',
  'app.tagline': 'Eğitim ve proses simülasyonu',
  'app.untitledProject': 'Adsız',

  // ---- Toolbar ----------------------------------------------------------
  'toolbar.label': 'Araç çubuğu',
  'toolbar.group.file': 'Dosya işlemleri',
  'toolbar.group.edit': 'Düzenleme işlemleri',
  'toolbar.group.modes': 'Çalışma modları',
  'toolbar.group.run': 'Çalıştırma kontrolleri',
  'toolbar.new': 'Yeni',
  'toolbar.open': 'Aç',
  'toolbar.save': 'Kaydet',
  'toolbar.undo': 'Geri al',
  'toolbar.redo': 'Yinele',
  'toolbar.run': 'Çalıştır',
  'toolbar.pause': 'Duraklat',
  'toolbar.step': 'Adım',
  'toolbar.reset': 'Sıfırla',
  'toolbar.stop': 'Durdur',
  'toolbar.theme.light': 'Açık Tema',
  'toolbar.theme.dark': 'Koyu Tema',
  'toolbar.settings': 'Ayarlar',
  'toolbar.help': 'Yardım',
  'toolbar.unavailable': 'Bu özellik sonraki geliştirme fazında kullanılabilir olacaktır.',
  'toolbar.confirmNew': 'Kaydedilmemiş değişiklikler var. Yeni projeye başlamak istiyor musunuz?',
  'toolbar.confirmOpen': 'Kaydedilmemiş değişiklikler var. Başka bir proje açmak istiyor musunuz?',

  // ---- Modes ------------------------------------------------------------
  'mode.design': 'Tasarım',
  'mode.program': 'Program',
  'mode.workshop': 'Atölye',
  'mode.hmi': 'HMI',
  'mode.simulation': 'Simülasyon',
  'mode.monitor': 'İzleme',
  'mode.debug': 'Hata Ayıklama',
  'mode.design.description': 'Sahneyi ve cihazları tasarlayın',
  'mode.program.description': 'Ladder programını yazın',
  'mode.workshop.description': 'Elektrik kumanda ve şema atölyesi',
  'mode.hmi.description': 'Operatör (HMI) ekranlarını tasarlayın',
  'mode.simulation.description': 'Prosesi çalıştırın ve gözlemleyin',
  'mode.monitor.description': 'PLC değişkenlerini izleyin',
  'mode.debug.description': 'Programı adım adım inceleyin',

  // ---- Workspace --------------------------------------------------------
  'workspace.label': 'Çalışma alanı',
  'workspace.design.title': 'Sahne Oluşturucu',
  'workspace.program.placeholder':
    'Ladder editörü sonraki geliştirme fazında kullanılabilir olacaktır.',
  'workspace.simulation.placeholder':
    'Simülasyon motoru sonraki geliştirme fazında kullanılabilir olacaktır.',
  'workspace.monitor.placeholder':
    'İzleme araçları sonraki geliştirme fazında kullanılabilir olacaktır.',
  'workspace.debug.placeholder':
    'Hata ayıklama araçları sonraki geliştirme fazında kullanılabilir olacaktır.',
  'workspace.placeholder.badge': 'Yakında',
  'scene.label': 'Sahne alanı',
  'scene.empty.title': 'Boş sahne',
  'scene.empty.description': 'Toolbox’tan bir komponent ekleyin.',
  'scene.zoom.in': 'Yakınlaştır',
  'scene.zoom.out': 'Uzaklaştır',
  'scene.zoom.reset': 'Görünümü Sıfırla (%100)',
  'scene.zoom.fit': 'Ortala / Sığdır',

  // ---- Components panel -------------------------------------------------
  'components.title': 'Komponentler',
  'components.label': 'Komponent araç kutusu',
  'components.soon': 'Yakında',
  'components.category.input': 'Giriş',
  'components.category.output': 'Çıkış',
  'components.category.mechanical': 'Mekanik',
  'components.category.process': 'Proses',
  'components.category.network': 'Haberleşme',
  'components.empty.title': 'Komponent yok',
  'components.empty.description': 'Kayıtlı bir komponent bulunamadı.',

  // ---- Device types -----------------------------------------------------
  'device.button.name': 'Buton',
  'device.button.description': 'Basılınca PLC girişini değiştiren buton.',
  'device.switch.name': 'Anahtar',
  'device.switch.description': 'Konumunu koruyan seçici veya toggle anahtar.',
  'device.emergency-stop.name': 'Acil Stop',
  'device.emergency-stop.description': 'Basılınca kilitlenen güvenlik butonu.',
  'device.sensor.name': 'Sensör',
  'device.sensor.description': 'Nesne algılayan yaklaşım veya fotoelektrik sensör.',
  'device.lamp.name': 'Lamba',
  'device.lamp.description': 'PLC çıkışıyla yanan gösterge lambası.',
  'device.motor.name': 'Motor',
  'device.motor.description': 'PLC çıkışıyla çalışan elektrik motoru.',
  'device.buzzer.name': 'Buzzer',
  'device.buzzer.description': 'PLC çıkışıyla ses veren uyarı cihazı.',
  'device.fan.name': 'Soğutma Fanı',
  'device.fan.description': 'PLC çıkışıyla çalışan AC soğutma fanı.',
  'device.conveyor.name': 'Konveyör',
  'device.conveyor.description': 'Ürünleri taşıyan bant sistemi.',
  'device.cylinder.name': 'Silindir',
  'device.cylinder.description': 'Pnömatik ileri-geri hareketli silindir.',
  'device.valve.name': 'Solenoid Valf',
  'device.valve.description': 'Elektromanyetik bobin kontrollü endüstriyel akış açma/kapama valfi.',
  'device.tank.name': 'Tank',
  'device.tank.description': 'Seviyesi izlenen sıvı deposu.',
  'device.pump.name': 'Pompa',
  'device.pump.description': 'Sıvıyı hareket ettiren pompa.',
  'device.mixer.name': 'Mikser Motoru',
  'device.mixer.description': 'Tank içine dikey bağlanan şaftlı ve pervaneli sıvı karıştırıcı motor.',
  'device.product.name': 'Ürün',
  'device.product.description': 'Konveyör üzerinde taşınan kutu veya ürün.',
  'device.jam-sensor.name': 'Sıkışma Sensörü',
  'device.jam-sensor.description': 'Konveyör üzerindeki ürün sıkışmalarını algılar.',
  'device.level-sensor.name': 'Sıvı Seviye Sensörü',
  'device.level-sensor.description': 'Tank veya depodaki sıvı seviyesini analog (0-10V / 4-20mA) olarak ölçer.',
  'device.pid-controller.name': 'PID Kontrolör',
  'device.pid-controller.description': 'Süreç değişkenini (PV) hedefe (SP) ulaştıran endüstriyel PID kontrol birimi.',
  'device.modbus-server.name': 'Modbus TCP Sunucu',
  'device.modbus-server.description': 'Endüstriyel PLC haberleşmesi için Modbus TCP sunucu (Slave) simülatörü.',
  'device.modbus-client.name': 'Modbus TCP İstemci',
  'device.modbus-client.description': 'Modbus TCP sunucudan veri okuyan ve yazan istemci (Master).',

  // ---- Properties panel -------------------------------------------------
  'properties.title': 'Özellikler',
  'properties.label': 'Özellikler paneli',
  
  // Device Properties
  'properties.color': 'Renk',
  'properties.variant': 'Model / Tip',
  'device.motor.standard': '3 Fazlı AC Motor',
  'device.motor.pumpMotor': 'Pompalı Motor Grubu',
  'device.motor.fan': 'Soğutma Fanı (AC Single)',
  'variant.standard': 'Standart AC Motor',
  'variant.pump_motor': 'Pompa Motoru',
  'variant.fan': 'Soğutma Fanı',
  'variant.mixer': 'Dikey Mikser Motoru',
  'sensor.variant.photoelectric': 'Fotoelektrik Işın Sensörü',
  'sensor.variant.inductive': 'Endüktif Yaklaşım Sensörü (Metal)',
  'sensor.variant.capacitive': 'Kapasitif Sensör (Üniversal)',
  'sensor.variant.light_curtain': 'Optik Işık Bariyeri',
  'properties.sensingRange': 'Algılama Mesafesi (px)',
  'properties.logicType': 'Kontak Mantığı',
  'logic.no': 'Normalde Açık (NO)',
  'logic.nc': 'Normalde Kapalı (NC)',
  'properties.buttonLabel': 'Etiket',
  'properties.motorId': 'Motor ID',
  'properties.length': 'Uzunluk',
  'properties.width': 'Genişlik',
  'properties.speed': 'Hız (px/s)',
  'properties.direction': 'Yön',
  'direction.right': 'Sağa (İleri)',
  'direction.left': 'Sola (Geri)',
  'properties.endAction': 'Bant Sonu Davranışı',
  'endAction.dropOff': 'Hattan Düşsün (Toplama Kasası)',
  'endAction.stopper': 'Mekanik Stoper (Sıkışma Alarmı)',
  'properties.minSpacing': 'Min. Boşluk',
  'properties.jamThreshold': 'Sıkışma Süresi (ms)',
  'properties.outputConveyor': 'Çıkış Konveyörü',
  'properties.conveyorId': 'Konveyör ID',
  'properties.capacity': 'Kapasite (Litre)',
  'properties.initialLevel': 'Başlangıç Seviyesi (L)',
  'properties.inletCount': 'Giriş Borusu Sayısı',
  'properties.inlet1': '1 Giriş (Üst)',
  'properties.inlet2': '2 Giriş (Sol)',
  'properties.inlet3': '3 Giriş (Sol)',
  'properties.inlet4': '4 Giriş (Sol)',
  'properties.tankId': 'Bağlı Tank ID',
  'properties.bladeType': 'Pervane Tipi',
  'properties.rpm': 'Dönüş Hızı (RPM)',
  'blade.propeller': 'Gemi Tipi Pervane (Marine)',
  'blade.turbine': 'Türbin Çarkı (Rushton)',
  'blade.anchor': 'Çapa / Sıyırıcı (Anchor)',
  'properties.voltage': 'Bobin Gerilimi',
  'properties.valveType': 'Valf Tipi',
  'valve.nc': 'Normalde Kapalı (NC)',
  'valve.no': 'Normalde Açık (NO)',
  'voltage.24vdc': '24V DC',
  'voltage.230vac': '230V AC',
  'voltage.12vdc': '12V DC',
  'properties.nominalFlowRate': 'Nominal Debi (L/s)',
  'properties.maxFlowRate': 'Maksimum Debi (L/s)',
  'properties.sourceId': 'Giriş Kaynak ID',
  'properties.targetId': 'Çıkış Hedef ID',
  'properties.minLevel': 'Min Seviye (L)',
  'properties.maxLevel': 'Maks Seviye (L)',
  'properties.signalType': 'Sinyal Tipi',
  'signal.0_10V': '0 - 10 V (Analog Gerilim)',
  'signal.4_20mA': '4 - 20 mA (Analog Akım)',
  'properties.pvSource': 'PV Kaynak (Sensör ID)',
  'properties.cvTarget': 'CV Hedef (Aktüatör ID)',
  'properties.controlMode': 'Kontrol Modu',
  'properties.workMode': 'Çalışma Modu',
  'properties.setpoint': 'Hedef Değer (SP)',
  'properties.manualCv': 'Manuel Çıkış (CV %)',
  'properties.kp': 'Oransal Kazanç (Kp)',
  'properties.ki': 'İntegral Katsayısı (Ki)',
  'properties.kd': 'Türev Katsayısı (Kd)',
  'properties.sampleTimeMs': 'Örnekleme Zamanı (ms)',
  'properties.minOutput': 'Min Çıkış (%)',
  'properties.maxOutput': 'Maks Çıkış (%)',
  'P': 'P (Oransal)',
  'PI': 'PI (Oransal-İntegral)',
  'PID': 'PID (Oransal-İntegral-Türev)',
  'AUTO': 'Otomatik (AUTO)',
  'MANUAL': 'Manuel (MANUAL)',
  'properties.unitId': 'Unit ID',
  'properties.isOnline': 'Çevrimiçi (Online)',
  'properties.serverId': 'Sunucu ID',
  'properties.functionCode': 'Fonksiyon Kodu (FC)',
  'properties.startAddress': 'Başlangıç Adresi',
  'properties.quantity': 'Miktar / Adet',
  'properties.writeValues': 'Yazılacak Değerler',
  'properties.trigger': 'Tetikleme Değişkeni',
  'properties.delayMs': 'Sorgu Gecikmesi (ms)',
  
  // Colors
  'color.green': 'Yeşil',
  'color.red': 'Kırmızı',
  'color.yellow': 'Sarı',
  'color.blue': 'Mavi',
  'color.industrialBlue': 'Endüstriyel Mavi',
  'color.cyan': 'Camgöbeği / Turkuaz',
  'color.gray': 'Gri / Antrasit',
  'color.orange': 'Turuncu',
  'color.white': 'Beyaz',
  'properties.empty.title': 'Nesne seçilmedi',
  'properties.empty.description': 'Özelliklerini görmek için bir nesne seçin.',
  'properties.noSchema': 'Bu nesne için düzenlenebilir özellik tanımlı değil.',
  'properties.general': 'Genel',
  'properties.field.id': 'Kimlik',
  'properties.field.type': 'Tür',
  'properties.field.name': 'İsim / Etiket',
  'properties.showNameLabel': 'İsim Etiketini Göster',
  'properties.ladder.address': 'PLC Adresi / Tag',
  'properties.ladder.presetTime': 'Ön Ayar Süresi (PT)',
  'properties.ladder.presetValue': 'Ön Ayar Değeri (PV)',
  'properties.ladder.in1': 'Giriş 1 (IN1)',
  'properties.ladder.in2': 'Giriş 2 (IN2)',
  'properties.ladder.in': 'Giriş (IN)',
  'properties.ladder.out': 'Çıkış Adresi (OUT)',
  'properties.ladder.opType': 'Operatör / Eleman Tipi',
  'properties.ladder.label': 'Etiket (Label)',
  'properties.ladder.min': 'Alt Sınır (MIN)',
  'properties.ladder.max': 'Üst Sınır (MAX)',
  'properties.ladder.inMin': 'Giriş Min (IN_MIN)',
  'properties.ladder.inMax': 'Giriş Maks (IN_MAX)',
  'properties.ladder.outMin': 'Çıkış Min (OUT_MIN)',
  'properties.ladder.outMax': 'Çıkış Maks (OUT_MAX)',
  'properties.type.network': 'Network',
  'properties.type.wire': 'Kablo',

  // ---- Bottom panel -----------------------------------------------------
  'bottom.label': 'Alt panel',
  'bottom.tabs.label': 'Alt panel sekmeleri',
  'bottom.tab.ladder': 'Ladder',
  'bottom.tab.variables': 'Değişkenler',
  'bottom.tab.plcMonitor': 'PLC İzleme',
  'bottom.tab.alarms': 'Alarmlar',
  'bottom.tab.events': 'Olaylar',
  'bottom.tab.diagnostics': 'Tanılama',
  'bottom.tab.modbus': 'Modbus İzleme',
  'bottom.tab.console': 'Konsol',
  'bottom.placeholder.ladder': 'Ladder programı burada görüntülenecek.',
  'bottom.placeholder.variables': 'Tag ve değişken tablosu burada görüntülenecek.',
  'bottom.placeholder.plcMonitor': 'PLC giriş/çıkış durumları burada görüntülenecek.',
  'bottom.placeholder.events': 'Simülasyon olayları burada listelenecek.',
  'bottom.placeholder.diagnostics': 'Tanılama bilgileri burada görüntülenecek.',
  'bottom.placeholder.modbus': 'Modbus haberleşme durumları burada görüntülenecek.',
  'bottom.modbus.noServers': 'Projede Modbus Sunucusu bulunmuyor.',
  'bottom.placeholder.console': 'Sistem mesajları burada görüntülenecek.',
  'bottom.placeholder.title': 'Henüz içerik yok',

  // ---- Status bar -------------------------------------------------------
  'status.label': 'Durum çubuğu',
  'status.ready': 'Hazır',
  'status.cpu': 'CPU',
  'status.fps': 'FPS',
  'status.plc': 'PLC',
  'status.plc.notRunning': 'Çalışmıyor',
  'status.simulation': 'Simülasyon',
  'status.simulation.stopped': 'Durdu',
  'status.simulation.running': 'Çalışıyor',
  'status.simulation.paused': 'Duraklatıldı',
  'status.project': 'Proje',
  'status.panels.label': 'Panel görünürlüğü',
  'status.panel.left': 'Komponent panelini göster/gizle',
  'status.panel.right': 'Özellikler panelini göster/gizle',
  'status.panel.bottom': 'Alt paneli göster/gizle',
  'status.panel.developer': 'Geliştirici panelini göster/gizle',
  'status.unavailable': '--',

  // ---- Developer panel --------------------------------------------------
  'developer.title': 'Geliştirici',
  'developer.label': 'Geliştirici paneli',
  'developer.fps': 'FPS',
  'developer.frameTime': 'Kare süresi',
  'developer.plcScan': 'PLC scan',
  'developer.simulationTime': 'Simülasyon zamanı',
  'developer.simulationSpeed': 'Simülasyon hızı',
  'developer.activeDevices': 'Aktif cihaz',
  'developer.eventQueue': 'Olay kuyruğu',
  'developer.renderObjects': 'Çizilen nesne',
  'developer.uiSnapshotRate': 'UI snapshot hızı',

  // ---- Settings ---------------------------------------------------------
  'settings.title': 'Ayarlar',
  'settings.close': 'Kapat',
  'settings.language': 'Dil',
  'settings.language.tr': 'Türkçe',
  'settings.language.en': 'English',
  'settings.theme': 'Tema',
  'settings.theme.light': 'Açık',
  'settings.theme.dark': 'Koyu',
  'settings.developer': 'Geliştirici panelini göster',
  'settings.shortcuts': 'Klavye kısayolları',

  // ---- Shortcuts --------------------------------------------------------
  'shortcut.save': 'Kaydet',
  'shortcut.undo': 'Geri al',
  'shortcut.redo': 'Yinele',
  'shortcut.delete': 'Seçili nesneyi sil',
  'shortcut.escape': 'Seçimi kaldır / iletişim kutusunu kapat',
  'shortcut.toggleDeveloper': 'Geliştirici panelini aç/kapat',

  // ---- Notifications ----------------------------------------------------
  'toast.featureUnavailable': 'Bu özellik henüz kullanılamıyor.',
  'toast.nothingSelected': 'Hiçbir nesne seçili değil.',
  'toast.dismiss': 'Bildirimi kapat',
  'toast.region': 'Bildirimler',
  'toast.compileSuccess': 'Derleme başarılı.',
  'toast.compileFailed': 'Derleme başarısız. Lütfen hataları kontrol edin.',
  'toast.projectOpened': 'Proje başarıyla yüklendi.',
  'toast.projectOpenError': 'Proje dosyası açılamadı.',
  'toast.projectSaved': 'Proje başarıyla kaydedildi.',
  'toast.projectSaveError': 'Proje kaydedilemedi.',
  'toast.undoRedoWip': 'Geri al/Yinele özelliği henüz yapım aşamasındadır.',

  // ---- HMI Properties ----------------------------------------------------
  'hmi.prop.x': 'X Pozisyonu',
  'hmi.prop.y': 'Y Pozisyonu',
  'hmi.prop.width': 'Genişlik',
  'hmi.prop.height': 'Yükseklik',
  'hmi.prop.label': 'Etiket',
  'hmi.prop.color': 'Renk',
  'hmi.prop.behavior': 'Davranış',
  'hmi.prop.momentary': 'Bas-Bırak (Momentary)',
  'hmi.prop.toggle': 'Kalıcı (Toggle)',
  'hmi.prop.bindingType': 'Veri Bağlantı Tipi',
  'hmi.prop.none': 'Bağlantı Yok',
  'hmi.prop.plc': 'PLC Adresi / Değişkeni',
  'hmi.prop.modbus': 'Modbus Register',
  'hmi.prop.alarm': 'Alarm Sistemi',
  'hmi.prop.address': 'Adres / Değişken Adı',
  'hmi.prop.scaleMin': 'Ölçek Minimum',
  'hmi.prop.scaleMax': 'Ölçek Maksimum',

  // ---- Error boundary ---------------------------------------------------
  'error.title': 'Bir hata oluştu.',
  'error.description': 'Uygulama beklenmeyen bir durumla karşılaştı.',
  'error.retry': 'Yeniden dene',
  'error.details': 'Teknik ayrıntılar',

  // ---- Common -----------------------------------------------------------
  'common.loading': 'Yükleniyor…',

  // ---- Ladder Editor Drawing Mode ---------------------------------------
  'ladder.drawingMode': 'Çizim Modu',
  'ladder.drawingMode.hLine': 'Yatay Hat (H_LINE)',
  'ladder.drawingMode.hLineHint': 'Hücreler üzerinde sürükleyerek seri hat çizin. Çıkmak için Esc veya sağ tık.',
  'ladder.drawingMode.elementHint': 'Yerleştirmek için hücreye tıklayın. Çıkmak için Esc veya sağ tık.',
} as const;

export type TranslationKey = keyof typeof tr;
